/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Box, Checkbox, FormControlLabel } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { groupBy } from 'lodash';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

import {
  getDisputeAmountComputedFields,
  getDisputeNdcCodes,
  exportAllPDFForDisputeAmountComputedFields,
  setPaginationIndex,
  exportAllPDFForDisputeNdcCodes,
} from '../Store/actions';
import PaginationBox from './PaginationBox';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  disputeAmountsTableHead,
  exportAllPDFTableHead,
  ndcTableHeads,
} from './tableHeads';
import { exportAllPDF } from './ExportAll';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

const DisplayManufacturerDisputedAmounts = () => {
  const dispatch = useDispatch();

  const {
    isLoading,
    amountNdcDetails,
    threshold,

    exportAllDataComputedFields,
    exportAllDataNDCCodes,
    displayObj: {
      selectedPlanType,
      rebateProgram,
      selectedRows,
      reportQuarter,
      useBalanceThreshold,
      plan,
      computedFileds,
      ndcCodes,
      dramsInvoice,
      earliestQtr,
      rebateProgramList,
      countValue,
      rebateProgrameName,
    },
  } = useSelector((state) => state?.sharedState?.DisputeAmountReducer);

  // selected rebate program short descript is calculayted from here
  const rebateProgramShortDesc = rebateProgrameName;
  // rebateProgram +
  // ' - ' +
  // (rebateProgramList.find((item) => item.rebateProgramCd === rebateProgram)
  //   ?.shortDescr || '');

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [rows, setRows] = React.useState(computedFileds);
  const [totalAmt, setTotalAmt] = React.useState('');
  const [ndcDetailsRows, setNdcDetailsRows] = React.useState([]);
  const [count, setCount] = React.useState(countValue || 1);
  const [selectedRowQuarter, setSelectedRowQuarter] = React.useState('');
  const [refresh, setRefresh] = React.useState(true);
  const [exportAllClicked, setExportAllClicked] = useState(false);
  const [applyPagination, setApplyPagination] = useState(false);

  const [ndcCodesData, setNdcCodesData] = React.useState(ndcCodes);
  const [paginationArray, setPaginationArray] = React.useState([
    ...Array(selectedRows?.length).keys(),
  ]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const ninethInfo = selectedRows.length > 1? "Manufacturer:All":`Manufacturer: ${selectedRows[count - 1]?.mfgId}`;
  /*
    This function handle the side effect of next previios of pagination box
  */
  React.useEffect(() => {
    if (countValue) {
      setCount(countValue || 1);
      setApplyPagination(true);
    }
  }, [countValue]);
  const handleClick = (type, value) => {
    dispatch(clearReduxForFilterAndSort('/displayManufacturerDisputedAmounts'));
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        dispatch(setPaginationIndex(paginationArray.length));
      } else {
        dispatch(setPaginationIndex(value));
      }
    }
  };

  /*
     this function handle the vlue like text in input box
  */
  const handleBlur = (value) => {
    dispatch(clearReduxForFilterAndSort('/displayManufacturerDisputedAmounts'));
    const numericValue = parseInt(value);
    let correctedValue = 1;
    if (isNaN(numericValue) || value === '' || numericValue < 1) {
      dispatch(setPaginationIndex(1));
    } else if (numericValue > paginationArray.length) {
      dispatch(setPaginationIndex(paginationArray.length));
      correctedValue = paginationArray.length;
    } else {
      dispatch(setPaginationIndex(numericValue));
      correctedValue = numericValue;
    }
      return correctedValue;
  };

  const handleDispatch = async () => {
      setRefresh(false);
      setApplyPagination(false);
      await dispatch(
        getDisputeAmountComputedFields({
          rebateProgramCd: rebateProgram,
          qtr:
            reportQuarter === 'All'
              ? '1Q1991'
              : reportQuarter === 'DRAMS Invoice Start Quarter'
              ? dramsInvoice
              : reportQuarter === 'Earliest Quarter for Drug Details'
              ? earliestQtr
              : '',
          mfg: selectedRows[count - 1]?.mfgId,
          thresh: useBalanceThreshold ? threshold : null,
        })
      );
      setRefresh(true);
  }

  React.useEffect(() => {
    if (selectedRows?.length > 1 && selectedRows[count - 1]?.mfgId) {
      handleDispatch();
      // const tId = setTimeout(() => {
      //   setRefresh(true);
      //   clearTimeout(tId);
      // }, 100);
    }
  }, [count]);

  const getDataWithOneQTR = (data) => {
    const groupedComputedFields = groupBy(data, 'qtr');
    const dataWithOneQTR = [];
    for (const key in groupedComputedFields) {
      let oneRow = {};
      for (let i = 0; i < groupedComputedFields[key]?.length; i += 1) {
        if (i === 0) {
          oneRow = { ...groupedComputedFields[key][i] };
        } else {
          oneRow.amt_IN_DISP += parseFloat(
            groupedComputedFields[key][i]?.amt_IN_DISP || 0
          );
          oneRow.totCurrQtrAmt += parseFloat(
            groupedComputedFields[key][i]?.totCurrQtrAmt || 0
          );

          oneRow.curr_AMT_DISP_DRUGS += parseFloat(
            groupedComputedFields[key][i]?.curr_AMT_DISP_DRUGS || 0
          );
          oneRow.pct_DISP_OF_TOT_INVOICE += parseFloat(
            100 *
              (parseFloat(oneRow?.amt_IN_DISP || 0) /
                parseFloat(oneRow.c_TOT || 0))
          );
          oneRow.pct_DISP_OF_DISP_DRUGS += parseFloat(
            100 *
              (parseFloat(oneRow?.amt_IN_DISP || 0) /
                parseFloat(oneRow.curr_AMT_DISP_DRUGS || 0))
          );
        }

        // if (i === groupedComputedFields[key]?.length - 1) {
        //   oneRow.pct_DISP_OF_TOT_INVOICE /= groupedComputedFields[key]?.length;
        //   oneRow.pct_DISP_OF_DISP_DRUGS /= groupedComputedFields[key]?.length;
        // }
      }
      dataWithOneQTR.push(oneRow);
    }
    return dataWithOneQTR;
  };

  React.useEffect(() => {
    let data = computedFileds || [];
    data = getDataWithOneQTR(data);
    if (data?.length > 0) {
      data = data?.map((item) => {
        const splittedQtr = item.qtr?.split('Q');
        return {
          ...item,
          amt_IN_DISP: parseFloat(item?.amt_IN_DISP?.toFixed(2)),
          totCurrQtrAmt: parseFloat(item?.totCurrQtrAmt?.toFixed(2)),
          pct_DISP_OF_TOT_INVOICE: parseFloat(
            100 *
              (parseFloat(item?.amt_IN_DISP || 0) / parseFloat(item.c_TOT || 0))
          )?.toFixed(4),

          curr_AMT_DISP_DRUGS: parseFloat(
            item?.curr_AMT_DISP_DRUGS?.toFixed(2)
          ),
          pct_DISP_OF_DISP_DRUGS: parseFloat(
            100 *
              (parseFloat(item?.amt_IN_DISP || 0) /
                parseFloat(item.curr_AMT_DISP_DRUGS || 0))
          )?.toFixed(4),
          quarter: splittedQtr[0],
          year: splittedQtr[1],
        };
      });
      data.sort((a, b) => a.year - b.year || a.quarter - b.quarter);
      setSelectedRowQuarter(data[0]?.qtr);
      const totalAmt = data.reduce((acc, obj) => acc + obj.amt_IN_DISP, 0);
      setTotalAmt(totalAmt);
    }

    setRows(data);
  }, [computedFileds]);

  React.useEffect(() => {
    setNdcCodesData(ndcCodes);
  }, [ndcCodes]);

  React.useEffect(() => {
    dispatch(
      getDisputeNdcCodes({
        mfg: selectedRows[count - 1]?.mfgId,
        qtr:
          reportQuarter === 'All'
            ? '1Q1991'
            : reportQuarter === 'DRAMS Invoice Start Quarter'
            ? dramsInvoice
            : reportQuarter === 'Earliest Quarter for Drug Details'
            ? earliestQtr
            : '',
        mfgType: plan === 'ST' || plan === 'FD' ? 'G' : 'C',
        rebateProgramCd: rebateProgram,
      })
    );
  }, [count]);

  React.useEffect(() => {
    // we have to combime two API data
    if (ndcCodesData && computedFileds && computedFileds.length) {
      const ndcCodes = ndcCodesData.filter(
        (data) => data.target_QTR === selectedRowQuarter
      );
      const drugSeqNumCodeMapping = {};
      for (let i = 0; i < ndcCodes.length; i += 1) {
        if (!drugSeqNumCodeMapping[ndcCodes[i].drug_SEQ_NUM]) {
          drugSeqNumCodeMapping[ndcCodes[i].drug_SEQ_NUM] = [ndcCodes[i]];
        } else {
          drugSeqNumCodeMapping[ndcCodes[i].drug_SEQ_NUM].push(ndcCodes[i]);
        }
      }
      const rows = computedFileds
        .filter((row) => row.qtr === selectedRowQuarter)
        .map((row) => {
          return {
            ndc: `${row.labelerCode}-${row.productCode}-${row.packageSize}`,
            drugName: row.drugName,
            amontInDispute: parseFloat(
              (row.disputedUnits * row.unitRebateAmt).toFixed(2)
            ),
            disputeCodes: drugSeqNumCodeMapping[row.drugSeqNum]
              ?.map((d) => d.disputeCd)
              ?.join(', '),
          };
        });
      rows.sort((a, b) => a.ndc - b.ndc || a.ndc - b.ndc);
      setNdcDetailsRows(rows);
    } else {
      setNdcDetailsRows([]);
    }
  }, [ndcCodesData, computedFileds, selectedRowQuarter]);

  // on selection changes , its sets the data for NDC table
  const onSelectionChanged = (e) => {
    const selectedRows = e.api.getSelectedRows();
    if (selectedRows.length) {
      setSelectedRowQuarter(selectedRows[0].qtr);
    }
  };

  const [exportFileName, setExportFileName] = React.useState(null);
  const exportAllToPDF = (name) => {
    setExportFileName(name);
    setExportAllClicked(true);
    dispatch(
      exportAllPDFForDisputeAmountComputedFields({
        rebateProgramCd: rebateProgram,
        qtr:
          reportQuarter === 'All'
            ? '1Q1991'
            : reportQuarter === 'DRAMS Invoice Start Quarter'
            ? dramsInvoice
            : reportQuarter === 'Earliest Quarter for Drug Details'
            ? earliestQtr
            : '',
        mfg: 'ALL',
        thresh: useBalanceThreshold ? threshold : null,
      })
    );
    dispatch(
      exportAllPDFForDisputeNdcCodes({
        mfg: 'ALL',
        qtr:
          reportQuarter === 'All'
            ? '1Q1991'
            : reportQuarter === 'DRAMS Invoice Start Quarter'
            ? dramsInvoice
            : reportQuarter === 'Earliest Quarter for Drug Details'
            ? earliestQtr
            : '',
        mfgType: plan === 'ST' || plan === 'FD' ? 'G' : 'C',
        rebateProgramCd: rebateProgram,
      })
    );
  };
   const exportToPDF = (name) => {
    setExportFileName(name);
    setExportAllClicked(true);
    dispatch(
      exportAllPDFForDisputeAmountComputedFields({
        rebateProgramCd: rebateProgram,
        qtr:
          reportQuarter === 'All'
            ? '1Q1991'
            : reportQuarter === 'DRAMS Invoice Start Quarter'
            ? dramsInvoice
            : reportQuarter === 'Earliest Quarter for Drug Details'
            ? earliestQtr
            : '',
        mfg: selectedRows[count - 1]?.mfgId,
        thresh: useBalanceThreshold ? threshold : null,
      })
    );
    dispatch(
      exportAllPDFForDisputeNdcCodes({
        mfg: selectedRows[count - 1]?.mfgId,
        qtr:
          reportQuarter === 'All'
            ? '1Q1991'
            : reportQuarter === 'DRAMS Invoice Start Quarter'
            ? dramsInvoice
            : reportQuarter === 'Earliest Quarter for Drug Details'
            ? earliestQtr
            : '',
        mfgType: plan === 'ST' || plan === 'FD' ? 'G' : 'C',
        rebateProgramCd: rebateProgram,
      })
    );
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  useEffect(() => {
    if (
      exportAllClicked &&
      exportAllDataComputedFields &&
      exportAllDataNDCCodes &&
      exportAllDataNDCCodes.length &&
      exportAllDataComputedFields.length
    ) {
      setApplyPagination(false);
      const groupByMfgIdComputedFields = groupBy(
        exportAllDataComputedFields,
        'mfgId'
      );

      const drugSeqNumCodeMapping = {};
      for (let i = 0; i < exportAllDataNDCCodes.length; i += 1) {
        if (
          !drugSeqNumCodeMapping[
            exportAllDataNDCCodes[i].drug_SEQ_NUM +
              exportAllDataNDCCodes[i].target_QTR
          ]
        ) {
          drugSeqNumCodeMapping[
            exportAllDataNDCCodes[i].drug_SEQ_NUM +
              exportAllDataNDCCodes[i].target_QTR
          ] = [exportAllDataNDCCodes[i]];
        } else {
          drugSeqNumCodeMapping[
            exportAllDataNDCCodes[i].drug_SEQ_NUM +
              exportAllDataNDCCodes[i].target_QTR
          ].push(exportAllDataNDCCodes[i]);
        }
      }

      for (const key in groupByMfgIdComputedFields) {
        groupByMfgIdComputedFields[key] = groupByMfgIdComputedFields[key].map(
          (row) => {
            const splittedQtr = row.qtr.split('Q');
            return {
              ...row,
              ndc: `${row.labelerCode}-${row.productCode}-${row.packageSize}`,
              drugName: row.drugName,
              amontInDispute: parseFloat(
                (row.disputedUnits * row.unitRebateAmt).toFixed(2)
              ),
              disputeCodes: drugSeqNumCodeMapping[row.drugSeqNum + row.qtr]
                ?.map((d) => d.disputeCd)
                ?.join(', '),
              pct_DISP_OF_DISP_DRUGS: parseFloat(
                row.pct_DISP_OF_DISP_DRUGS.toFixed(4)
              ),
              pct_DISP_OF_TOT_INVOICE: parseFloat(
                row.pct_DISP_OF_TOT_INVOICE.toFixed(4)
              ),
              quarter: splittedQtr[0],
              year: splittedQtr[1],
            };
          }
        );

        groupByMfgIdComputedFields[key].sort(
          (a, b) => a.year - b.year || a.quarter - b.quarter || a.ndc - b.ndc
        );
      }

      // Export all feature for PDF
      const mapping = {};
      for (let i = 0; i < exportAllDataComputedFields.length; i += 1) {
        mapping[
          exportAllDataComputedFields[i].mfgId
        ] = `${exportAllDataComputedFields[i].mfgId} ${exportAllDataComputedFields[i].mfgName}`;
      }
      const globalTotalAmountInDispute = exportAllDataComputedFields.reduce(
        (sum, row) => sum + (parseFloat(row.amt_IN_DISP) || 0),
        0
      );
      const options = {
        info: { thirdInfo, fourthInfo: firstInfo,fifthInfo },
        titleName: 'Manufacturer: ',
        mapping,
        pageSize: {
          width: 1000,
          height: 700,
        },
        globalTotalAmountInDispute,
        useBalanceThreshold,
        ninethInfo,
      };
      const paginationArr = Object.keys(groupByMfgIdComputedFields)?.sort();
      const widths = exportAllPDFTableHead.map((item, i) =>
        i == 2 ? 200 : i == 0 ? 50 : 82
      );
      const header = {
        reportName: 'Dispute Amounts Report',
        fileName: exportFileName,
      };
      if (exportAllClicked) {
        setExportAllClicked(false);
        exportAllPDF(
          header,
          groupByMfgIdComputedFields,
          exportAllPDFTableHead,
          userDefaults,
          options,
          paginationArr,
          widths,
          logInUser
        );
      }
    }
  }, [exportAllDataComputedFields, exportAllDataNDCCodes]);
  // Below variable are used for PDF header
  let firstInfo =
    reportQuarter === 'All'
      ? 'Report Quarter: All Quarter'
      : `Report Quarter: ${reportQuarter}`;
  const secondInfo = `Mfg: ${selectedRows[count - 1]?.mfgId} ${
    selectedRows[count - 1]?.mfgName
  }`;
  let thirdInfo = rebateProgramShortDesc;
  const fifthInfo = "";
    const fourthInfo = "";

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const sum = (property) => {
      const displayedRows = ndcDetailsRows ? ndcDetailsRows : [];  
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
      return data ;
  };
  
    const createData = (count, prefix) => {
      const result = [];
      for (let i = 0; i < count; i += 1) {
        result.push({
          isBottomRow: true,
          drugName: 'Total',
          amontInDispute: sum('amontInDispute'),
     
        });
      }
      return result;
    };
 
    const pinnedBottomRowData = useMemo(() => {
      return createData(1, 'Bottom');
    }, [ndcDetailsRows]);
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="Summary Reports"
        parent2="Display Dispute Amount"
      />
      <Spinner load={spinnerLoader} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-5">
                      <div className="col-12">
                        <div className="float-right">
                          <PaginationBox
                            array={paginationArray}
                            count={count}
                            handleClick={handleClick}
                            handleBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Plan: "
                          id="Plan"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={selectedPlanType}
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          label="Rebate Program: "
                          id="Rebate Program"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rebateProgramShortDesc}
                        />
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Manufacturer ID: "
                          id="Manufacturer ID"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={selectedRows[count - 1]?.mfgId}
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          label="Manufacturer Name: "
                          id="Manufacturer Name"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={selectedRows[count - 1]?.mfgName}
                        />
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-6">
                        <TextField
                          label="Quarter Options: "
                          id="Quarter Options"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={reportQuarter}
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          label="Total Amount in Dispute: "
                          id="Total Amount in Dispute"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={
                            totalAmt
                              ? `$ ${totalAmt.toLocaleString('en-US', {
                                  minimumFractionDigits: 2,
                                })}`
                              : '$ 0.00'
                          }
                        />
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-6">
                        <div className="filter-checkbox">
                          <FormControlLabel
                            control={
                              <>
                                <div style={{ width: 275, marginLeft: 5 }}>
                                  Use Report Balance Due Threshold:
                                </div>
                                <Checkbox
                                  color="primary"
                                  disabled
                                  checked={useBalanceThreshold}
                                />
                              </>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {refresh && (
          <div className="row" style={{ marginTop: 15 }}>
            <div className="unallocated" style={{ width: '100vw' }}>
              <TableGridWithFeatures
                gridHeight={viewPortHeight_355}
                onSelectionChanged={onSelectionChanged}
                columnDefs={disputeAmountsTableHead}
                rowData={rows || []}
                countValue={count}
                data-testid="onEditingStopped"
                enterMovesDown
                showResetFilter={false}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                selectRowIndex={0}
                hideTotalCount={false}
                exportFile
                fileName="DisputeAmounts"
                reportName="Dispute Amounts Report"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={changeFullScreenView}
                info={{ firstInfo, secondInfo, thirdInfo, fourthInfo,fifthInfo }}
                exportAllTpPDF={selectedRows.length > 1 ? exportAllToPDF : null}
                exportToPDF={exportToPDF}
                showExportPdfOption={false}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;
                    if (name && name.length > 20) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
              />
            </div>
            <div
              className="unallocated"
              style={{ width: '100vw', marginTop: 15 }}
            >
              <TableGridWithFeatures
                gridHeight={viewPortHeight_355}
                columnDefs={ndcTableHeads}
                rowData={ndcDetailsRows}
                rowMultiSelectWithClick
                data-testid="onEditingStopped2"
                enterMovesDown
                countValue={count}
                showResetFilter={false}
                defaultCol={{
                  wrapHeaderText: true,
                  autoHeaderHeight: true,
                }}
                pinnedBottomRowData={pinnedBottomRowData}
                isScrollOn
                hideTotalCount={false}
                exportFile
                fileName="DisputeAmounts"
                reportName="Dispute Amounts Report"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={changeFullScreenView}
                info={{ firstInfo, secondInfo, thirdInfo, fourthInfo,fifthInfo }}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;
                    if (name && name.length > 20) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DisplayManufacturerDisputedAmounts;
